import { Box, Typography, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import Icon from '../../../Assets/Icon/CustomIcon';

export default function M_DCM_BASIC(props) {
  const [selectedMainMenu, setSelectedMainMenu] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [filteredMenuStructure, setFilteredMenuStructure] = useState(
    props.menuStructure || []
  );
  const [isSearchMode, setIsSearchMode] = useState(false);
  const menuStructure = props.menuStructure || [];

  // 검색 실행 함수
  const ExecuteSearch = () => {
    const searchTerm = searchInput.trim().toLowerCase();
    props.searchRef.current.searchText = searchInput;

    if (!searchTerm) {
      // 검색어가 없으면 전체 메뉴 표시
      setFilteredMenuStructure(menuStructure);
      setIsSearchMode(false);
      setSelectedMainMenu(null);
      return;
    }

    // 중메뉴 검색
    const filtered = menuStructure
      .map((mainMenu) => {
        // 중메뉴 중에서 검색어와 일치하는 것만 필터링
        const filteredSubMenus = mainMenu.subMenus.filter((subMenu) =>
          subMenu.name.toLowerCase().includes(searchTerm)
        );

        // 검색 결과가 있으면 해당 대메뉴와 필터링된 중메뉴 반환
        if (filteredSubMenus.length > 0) {
          return {
            ...mainMenu,
            subMenus: filteredSubMenus,
          };
        }

        return null;
      })
      .filter((menu) => menu !== null);

    setFilteredMenuStructure(filtered);
    setIsSearchMode(true);

    // 검색 결과가 있으면 첫 번째 대메뉴 자동 선택 (이동하지 않고 필터링만)
    if (filtered.length > 0) {
      setSelectedMainMenu(filtered[0]);
    } else {
      setSelectedMainMenu(null);
    }
  };

  const HandleMainMenuClick = (mainMenu) => {
    setSelectedMainMenu(mainMenu);
    if (mainMenu.subMenus.length === 0) {
      // 하위 메뉴가 없으면 바로 리스트 화면으로
      if (props.onMenuSelect) {
        props.onMenuSelect(mainMenu.id, null);
      }
    }
  };

  const HandleSubMenuClick = (subMenu) => {
    if (props.onMenuSelect && selectedMainMenu) {
      props.onMenuSelect(selectedMainMenu.id, subMenu.id);
    }
  };

  const HandleSearch = () => {
    ExecuteSearch();
  };

  // 검색어 초기화
  const HandleClearSearch = () => {
    setSearchInput('');
    props.searchRef.current.searchText = '';
    setFilteredMenuStructure(menuStructure);
    setIsSearchMode(false);
    setSelectedMainMenu(null);
  };

  // 표시할 메뉴 구조 (검색 모드면 필터링된 결과, 아니면 전체)
  const displayMenuStructure = isSearchMode
    ? filteredMenuStructure
    : menuStructure;

  // 스플릿 뷰 구조: 상단 검색창, 좌측 대메뉴, 우측 소메뉴
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
      }}
    >
      {/* 상단 검색창 */}
      <Box
        sx={{
          flexShrink: 0,
          px: 2,
          py: 1.5,
          borderBottom: '1px solid #eee',
        }}
      >
        <Box
          sx={{
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            pr: '8px',
          }}
        >
          <input
            type="text"
            placeholder="중메뉴 검색"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                HandleSearch();
              }
            }}
            style={{
              height: '36px',
              fontSize: '16px',
              padding: '0 10px',
              border: 'none',
              outline: 'none',
              width: '100%',
              backgroundColor: 'transparent',
            }}
          />
          {searchInput ? (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={HandleClearSearch}
            >
              <Icon.Close />
            </button>
          ) : (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
              }}
              onClick={HandleSearch}
            >
              <Icon.Search />
            </button>
          )}
        </Box>
      </Box>

      {/* 스플릿 뷰: 좌측 대메뉴, 우측 소메뉴 */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {/* 좌측 대메뉴 */}
        <Box
          sx={{
            width: '120px',
            flexShrink: 0,
            borderRight: '1px solid #eee',
            overflowY: 'auto',
            bgcolor: '#f9f9f9',
          }}
        >
          {props.loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
              }}
            >
              <CircularProgress size={24} />
            </Box>
          ) : menuStructure.length === 0 ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                px: 1,
              }}
            >
              <Typography sx={{ color: '#888', fontSize: '12px' }}>
                조회된 메뉴가 없습니다.
              </Typography>
            </Box>
          ) : (
            displayMenuStructure.map((mainMenu) => (
              <Box
                key={mainMenu.id}
                onClick={() => HandleMainMenuClick(mainMenu)}
                sx={{
                  width: '100%',
                  px: 1.5,
                  py: 1.5,
                  cursor: 'pointer',
                  backgroundColor:
                    selectedMainMenu?.id === mainMenu.id
                      ? '#6c63e9ff'
                      : 'transparent',
                  color: selectedMainMenu?.id === mainMenu.id ? '#fff' : '#333',
                  borderBottom: '1px solid #eee',
                  '&:hover': {
                    backgroundColor:
                      selectedMainMenu?.id === mainMenu.id
                        ? '#6c63e9ff'
                        : '#f0f0f0',
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight:
                      selectedMainMenu?.id === mainMenu.id ? 'bold' : 'normal',
                    textAlign: 'center',
                  }}
                >
                  {mainMenu.name}
                </Typography>
              </Box>
            ))
          )}
        </Box>

        {/* 우측 소메뉴 */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            bgcolor: '#fff',
          }}
        >
          {!selectedMainMenu ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <Typography sx={{ color: '#888', fontSize: '14px' }}>
                좌측에서 대메뉴를 선택해주세요.
              </Typography>
            </Box>
          ) : selectedMainMenu.subMenus.length === 0 ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <Typography sx={{ color: '#888', fontSize: '14px' }}>
                {isSearchMode
                  ? '검색 결과가 없습니다.'
                  : '하위 메뉴가 없습니다.'}
              </Typography>
            </Box>
          ) : (
            <Box sx={{ p: 2 }}>
              {selectedMainMenu.subMenus.map((subMenu) => (
                <Box
                  key={subMenu.id}
                  onClick={() => HandleSubMenuClick(subMenu)}
                  sx={{
                    width: '100%',
                    border: '1px solid #DFD9D9',
                    borderRadius: '0.5rem',
                    padding: '1rem',
                    backgroundColor: '#fff',
                    cursor: 'pointer',
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                      borderColor: '#6c63e9ff',
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                    }}
                  >
                    {subMenu.name}
                  </Typography>
                  <Icon.BottomArrow
                    style={{
                      transform: 'rotate(-90deg)',
                      width: '20px',
                      height: '20px',
                      color: '#999',
                    }}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
